export const pairedPromocode = (eventDiscount, code, id) => {
  if (Number(eventDiscount) > 0 || !code || id == null || id === "") {
    return { promocode: null, promocode_id: null };
  }
  return { promocode: code, promocode_id: id };
};

export const pickupPromoCode = (eventDiscount, code) =>
  Number(eventDiscount) > 0 ? null : code || null;

export const cartProductIds = (cartLines) => [
  ...new Set(
    (cartLines || [])
      .map((line) => line?.product_id)
      .filter((id) => id != null)
  ),
];

export const promoPercentBase = (resData, cartLines, orderTotal) => {
  const productIds = Array.isArray(resData?.product_ids) ? resData.product_ids : [];
  const wholeCart = resData?.apply_whole_cart !== false || productIds.length === 0;
  if (wholeCart) {
    return { base: Number(orderTotal) || 0, scope: "order", productIds: [] };
  }
  const base = (cartLines || []).reduce((sum, line) => {
    const match = productIds.some((pid) => String(pid) === String(line?.product_id));
    if (!match) return sum;
    const lineTotal = Number(line?.overAllSum ?? line?.total ?? 0);
    return sum + (Number.isFinite(lineTotal) ? lineTotal : 0);
  }, 0);
  return { base, scope: "products", productIds };
};
